import classNames from "classnames";
import React, { FunctionComponent, useRef } from "react";
import { useIntl } from "react-intl";
import HeaderDropdown from "@Components/molecules/header/HeaderDropdown";
import useHeaderMenuActive from "@Hooks/header/useHeaderMenuActive";
import { Category } from "@Types/header";
import { setDataLayerTrack } from "@Utils/track";
import "./style.scss";

interface Props {
  category: Category;
}

const HeaderCategoryItem: FunctionComponent<Props> = ({ category }) => {
  const categoryRef = useRef<HTMLDivElement>(null);
  const intl = useIntl();
  const localeSlug = intl.locale;

  const { active, handleMouseEnter, handleMouseLeave, handleMouseLeaveMenu } =
    useHeaderMenuActive(categoryRef);

  const hasSubCategories: boolean = category.subCategories.length > 0;
  const hasHighlights: boolean = category.productHighlights
    ? category.productHighlights.length > 0
    : false;
  const hasDropdown: boolean = hasSubCategories || hasHighlights;
  const isCategoryActive = active && hasDropdown;

  return (
    <div
      className="HeaderCategoryItem"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={categoryRef}
    >
      <a
        className={classNames("HeaderCategoryItem-item", {
          "HeaderCategoryItem-item--active": isCategoryActive,
          "HeaderCategoryItem-item--featured": category.featured,
        })}
        href={`/${localeSlug}${category.url}`}
        key={category.tag}
        onClick={() =>
          setDataLayerTrack("Product List Clicked", {
            categoryPageTag: category.tag,
            linkPosition: "Menu",
          })
        }
        style={{ color: category.color }}
      >
        {category.title}
      </a>
      <div
        className={classNames("HeaderCategoryItem-dropdown", {
          "HeaderCategoryItem-dropdown--active": isCategoryActive,
        })}
      >
        <HeaderDropdown category={category} onMouseLeaveMenu={handleMouseLeaveMenu} />
      </div>
    </div>
  );
};

export default React.memo(HeaderCategoryItem);
